import { Injectable } from '@angular/core';

import { Session } from '@services/session';
import { PendoAnalytics } from '@services/pendo-analytics';

@Injectable()
export class DispatchExperimentTrackingService {
  private trackingData: any = {};

  constructor(
    private session: Session,
    private pendo: PendoAnalytics,
  ) {
    this.trackingData = {
      companyId: this.session.getCompany().id,
      userEmail: this.session.getUserEmail(),
    };
  }

  public track(eventName: string, data: any = this.trackingData) {
    this.pendo.trackEvent(eventName, {...this.trackingData, ...data});
  }
}
